import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import { Button } from '@olxbr/ds-core'
import { Link } from '@olxbr/ds-web'

const ViewWrapper = ({ direction, ...others }) => <View {...others} /> // eslint-disable-line
const Content = styled(ViewWrapper)`
  display: flex;
  flex-direction: ${props => props.direction};
  justify-content: center;
  align-items: center;
`

const CalloutLink = styled(Link)`
  margin-left: 6px;
  margin-right: 6px;
`

const CalloutButton = styled(Button)`
  margin-left: 6px;
  margin-right: 6px;
`

const formLabel = props => (
  <Content direction={props.direction}>
    <span className="typo-body-medium" style={{ fontWeight: props.fontWeight }}>
      {props.text}
    </span>
    {props.href && (
      <CalloutLink size="Medium" href={props.href} onClick={props.onClick}>
        {props.linkText}
      </CalloutLink>
    )}
    {!props.href && (
      <CalloutButton variant="link" size="small" onClick={props.onClick} disabled={props.disabled}>
        {props.linkText}
      </CalloutButton>
    )}
    {!!props.remainingText && (
      <span className="typo-body-medium" style={{ fontWeight: props.fontWeight }}>
        {props.remainingText}
      </span>
    )}
  </Content>
)

formLabel.propTypes = {
  text: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  preventHrefOnClick: PropTypes.bool,
  direction: PropTypes.oneOf(['row', 'column']),
  fontWeight: PropTypes.number,
  remainingText: PropTypes.string,
  disabled: PropTypes.bool,
}

formLabel.defaultProps = {
  preventHrefOnClick: true,
  direction: 'row',
  fontWeight: 400,
}

export default formLabel
